import { Booking } from '@rematter/frontend-lib-api-client/grpc/trade/booking_pb';
import { BookingStatus } from '@rematter/frontend-lib-api-client/grpc/trade/booking_pb';
import { Col, FieldDisplay, IDField, StatusTransition } from '@rematter/ui-web';

import { bookingStatusLabels } from '../enumLabels';

type BookingStatusTransitionDetailProps = {
  booking?: Booking;
  previousStatus: BookingStatus;
  newStatusLabel: string;
};

export const BookingStatusTransitionDetail = ({
  booking,
  previousStatus,
  newStatusLabel,
}: BookingStatusTransitionDetailProps) => {
  if (!booking) {
    return (
      <Col className="@BookingStatusTransitionDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@BookingStatusTransitionDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Booking</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={booking.id} />
          <FieldDisplay label="Booking Number" value={booking.documentNumber} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Status Change
        </span>
        <StatusTransition
          previousStatus={
            bookingStatusLabels[previousStatus] ?? `Unknown (${previousStatus})`
          }
          newStatus={newStatusLabel}
        />
      </Col>
    </Col>
  );
};
